import { Link } from "react-router-dom";
import { Newspaper, ArrowRight } from "lucide-react";
import PageHeader from "@/components/marketing/PageHeader";
import Newsletter from "@/components/marketing/Newsletter";
import { IMG, NEWS_ITEMS } from "@/data/content";
import { useSiteContent } from "@/lib/siteContent";

export default function NewsPage() {
  const site = useSiteContent();
  const updates = Array.isArray(site.news) && site.news.length ? site.news : NEWS_ITEMS;

  return (
    <div data-testid="news-page">
      <PageHeader
        overline="News & Resources"
        crumb="News"
        title="Ranger News, Project Milestones & Industry Updates"
        subtitle="The latest project breakthroughs, safety achievements, and community initiatives from our teams across Florida."
        image={IMG.vanguardBanner}
      />
      <section className="bg-rc-bg py-20">
        <div className="max-w-6xl mx-auto px-5">
          <div className="grid md:grid-cols-3 gap-5">
            {updates.map((update) => (
              <article key={update.title} className="bg-white border border-black/10 rounded-2xl p-7">
                <Newspaper className="text-rc-red mb-5" aria-hidden="true" />
                <p className="font-mono text-rc-red text-xs uppercase tracking-widest mb-2">{update.category || "Company Update"}</p>
                <h2 className="font-heading font-bold text-xl text-rc-blue">{update.title}</h2>
                <p className="mt-4 text-rc-brown text-sm">{update.summary}</p>
              </article>
            ))}
          </div>
          <div className="mt-12 bg-rc-charcoal rounded-2xl p-8 text-white flex flex-wrap items-center justify-between gap-5">
            <div>
              <h2 className="font-heading text-2xl font-black">The VanGuard Corporate Magazine</h2>
              <p className="text-white/70 mt-1">In-depth stories, employee spotlights, and heavy construction features from across the Vecellio Group.</p>
            </div>
            <Link to="/news/vanguard-magazine" className="bg-rc-red rounded-full px-6 py-3 font-bold inline-flex items-center gap-2">
              Read the Current Issue <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
      <Newsletter />
    </div>
  );
}
